<ng-template #itemPreview>
  <div class="dialog-container">
    <div class="dialog-heading">
      <h2 mat-dialog-title>{{'itemDetails.TabQuestions.preview.heading' | translate}}</h2>
      <span class="spacer"></span>
      <div class="btn-close">
        <button mat-icon-button aria-label="Close Dialog" (click)="onClosePreview()"><mat-icon>close</mat-icon></button>
      </div>
    </div>
    <div mat-dialog-content>
      <div class="table-container">
        <table mat-table [dataSource]="questions" class="mat-elevation-z8
          question-details" #table>

          <ng-container matColumnDef="itemBankName">
            <th class="heading" mat-header-cell *matHeaderCellDef>{{'itemDetails.TabQuestions.preview.label' | translate}} : {{itemBasicDetails.numberOfQuestions}}</th>
            <td mat-cell *matCellDef="let row" class="cell-content">
              <div class="div-content" *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceOptions &&
                row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceOptions) || (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceOptions)
                || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceOptions)">

                <app-preview-multiple-choice-multiple-response [isReadOnly]='true' [questions]='row' [displayMode]=row?.questiondisplayoptions>
                </app-preview-multiple-choice-multiple-response>
              </div>
              <div class="div-content" *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceOptions &&
                row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceStandard) || (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceStandard)
                || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceStandard)">

                <app-preview-multiple-choice-single-response [isReadOnly]='true' [questions]='row' [displayMode]=row?.questiondisplayoptions>
                </app-preview-multiple-choice-single-response>
              </div>
              <div class="div-content" *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceOptions &&
                row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceYesOrNo) || (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceYesOrNo)
                || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceYesOrNo)">

                <app-preview-multiple-choice-true-or-false [isReadOnly]='true' [questions]='row' [displayMode]=row?.questiondisplayoptions>
                </app-preview-multiple-choice-true-or-false>
              </div>

              <div class="div-content" *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.Matrix &&
                row?.questionSubtypeId == QuestionSubTypeIdEnum.Matrix) || (row?.questionTypeId == QuestionTypeIdEnum.Matrix_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_Matrix)">
                <app-preview-matrix-single-choice [isReadOnly]='true' [questions]='row'>
                </app-preview-matrix-single-choice>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Descriptive &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.Descriptive">
                <app-preview-descriptive-plain-text [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-descriptive-plain-text>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveySingleChoice &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveySingleChoice">
                <app-preview-survey-single-choice [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-single-choice>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyMultiResponse &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyMultiResponse">
                <app-preview-survey-multi-response [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-multi-response>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyShortAnswer &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyShortAnswer">
                <app-preview-survey-short-answer [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-short-answer>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyLikeDislike &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyLikeDislike">
                <app-preview-survey-like-dislike [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-like-dislike>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyStarRating &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyStarRating">
                <app-preview-survey-star-rating [isReadOnly]='true' [questions]='row' [numberOfStarList]='row.options'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-star-rating>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyNumberRating &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyNumberRating">
                <app-preview-survey-number-rating [isReadOnly]='true' [questions]='row' [optionOfNumber]='row.options'
                  [displayMode]=row?.questiondisplayoptions></app-preview-survey-number-rating>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.FillInTheBlanks &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.FillInTheBlanks">
                <app-preview-fill-in-the-blank-text [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-fill-in-the-blank-text>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.MatchOrder">
                <app-preview-match-order-match-list [isReadOnly]='true' [questions]='row'
                  [displayMode]=row?.questiondisplayoptions></app-preview-match-order-match-list>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Hotspot && row?.questionSubtypeId == QuestionSubTypeIdEnum.HotspotSingleChoice">
                <app-preview-hotspot-question [questions]='row'></app-preview-hotspot-question>
              </div>
              <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Hotspot && row?.questionSubtypeId == QuestionSubTypeIdEnum.HotspotMultiChoice">
                <app-preview-hotspot-multi-choice [questions]='row'></app-preview-hotspot-multi-choice>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="itemDescription">
            <th mat-header-cell *matHeaderCellDef class="icon-td"> </th>
            <td mat-cell *matCellDef="let row">

            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</ng-template>
